import { JobsSection, Section, type Jobs } from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import { Box } from 'braid-design-system';
import { useScrollToTop } from '../../../../shared/utils/useScrollToTop';
import type { SalariesTabModel } from '../../../pages/salaries/salariesTabModel';
import translations from './.vocab/index';

interface OpenJobsSectionProps {
  getPaginatedJobs: (organisationId: string, page?: number) => Promise<Jobs>;
  model: Pick<SalariesTabModel, 'jobsModel'>;
  trackJobsPaginationClicked: ({
    searchTotalCount,
    pageNumber,
  }: {
    pageNumber: number;
    searchTotalCount?: number;
  }) => void;
}

export const OpenJobsSection = ({
  model,
  getPaginatedJobs,
  trackJobsPaginationClicked,
}: OpenJobsSectionProps) => {
  const { jobsModel } = model;
  const { t } = useTranslations(translations);
  const { scrollToTopRef, scrollToTop } = useScrollToTop('SECTION');

  return (
    <Box ref={scrollToTopRef}>
      <Section mode={'view'} heading={t('Open jobs')} padding={'none'}>
        <JobsSection
          mode="view"
          model={jobsModel}
          getPaginatedJobs={getPaginatedJobs}
          trackJobsPaginationClicked={trackJobsPaginationClicked}
          scrollToTop={scrollToTop}
          setSmallerTitle={true}
        />
      </Section>
    </Box>
  );
};
